import get from 'lodash/get';

class PerformanceEntries {
  resourceTimingByURL = {};

  _getPerformanceResourceTiming = () => {
    return get(window, 'performance.getEntries') ? window.performance.getEntries() : [];
  };

  _getShortResourceName = (name) => {
    let shortResourceName = '';

    try {
      const url = new URL(name);
      shortResourceName = url.pathname + url.search;
    } catch (e) {
      shortResourceName = name;
    }

    return shortResourceName.substring(0, 100);
  };

  updateResourceTimingByURL() {
    const entries = this._getPerformanceResourceTiming();

    entries.forEach((entry) => {
      const name = this._getShortResourceName(entry.name);
      const resource = this.resourceTimingByURL[name];
      if (!resource) {
        this.resourceTimingByURL[name] = [Math.round(entry.duration)];
      } else if (resource[resource.length - 1] !== Math.round(entry.duration)) {
        this.resourceTimingByURL[name].push(Math.round(entry.duration));
      }
    });
  }

  getStatisticChunksForUsabilla() {
    this.updateResourceTimingByURL();
    const statsStr = JSON.stringify(this.resourceTimingByURL);
    // A string which is passed to Usabilla can include only up to 500 characters
    const chunks = statsStr.match(/.{1,499}/g);

    return chunks.reduce((memo, chunk, index) => {
      return {
        ...memo,
        [`p${index}`]: chunk,
      };
    }, {});
  }
}

export default new PerformanceEntries();
